/**
 * YourSupport Module
 * Main entry point for the support ticket management system
 *
 * Features:
 * - Ticket creation and management
 * - Comment and collaboration
 * - File attachments
 * - Ticket categorization and filtering
 * - Dashboard and analytics
 *
 * Routes:
 * - /app/yoursupport - Dashboard
 * - /app/yoursupport/tickets - Ticket list
 * - /app/yoursupport/tickets/new - Create ticket
 * - /app/yoursupport/tickets/:id - View ticket details
 * - /app/yoursupport/tickets/:id/edit - Edit ticket
 */

// Export routes
export { default as yourSupportRoutes } from './routes/config';

// Export pages
export { default as Dashboard } from './pages/Dashboard';
export { default as TicketList } from './pages/TicketList';
export { default as TicketDetails } from './pages/TicketDetails';
export { default as TicketForm } from './pages/TicketForm';

// Export services
export { default as ticketService } from './services/ticketService';

// Export types
export type {
  Ticket,
  Comment,
  Attachment,
  TicketStatus,
  TicketPriority,
  TicketSeverity,
  TicketFilters
} from './types';

import type { Module } from '../../../modules/index';
import { yourSupportRoutes } from './routes/config';

const dsHelpdeskModule: Module = {
  name: 'ds-helpdesk',
  path: '/app/yoursupport',
  routes: yourSupportRoutes,
};

export default dsHelpdeskModule;
